module.exports = __webpack_public_path__ + "static/media/HWSM-pic-R.cf672721.PNG";